export const actionTypes = {
  GET_API_DATA: 'GET_API_DATA',
  SHOW_PROFILE: 'SHOW_PROFILE'
};
